/**
 * ImageSlider - simple image slider block.
 * Custom element: <image-slider>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class ImageSlider extends ThemeComponent {}
setFunctionName(ImageSlider, "ImageSlider");
const propertyTypes = {};
ImageSlider.prototype.$name = "ImageSlider";
ImageSlider.prototype.$info = JSON.parse('{"name":"ImageSlider","meta":{"isLegacy":false,"selector":"image-slider"},"props":[],"refs":[]}');
ImageSlider.prototype.$info.component = ImageSlider;
for (const prop of ImageSlider.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("ImageSlider/ImageSlider.ts", {
  ImageSlider: ImageSlider
}, void 0);